'use strict';

var Params = function Params(containerWidth, containerHeight) {
  var padding = {
    top: 40,
    bottom: 88,
    left: 5,
    right: 20
  };
  var yAxisShift = -67;
  var width = containerWidth - (padding.left + padding.right);
  var height = containerHeight - (padding.top + padding.bottom);
  return {
    width: width,
    height: height,
    containerWidth: containerWidth,
    containerHeight: containerHeight,
    padding: padding,
    // Y-axis
    yNumberOfTicks: 5,
    yAxisShift: yAxisShift,
    yAxisLabelShift: -10,
    yAxisRightLabelShift: 50,
    yAxisRightShift: 0,
    yAxisTextRotationAnchor: 'middle',
    xAxisTextShift: 10,
    yAxisLabelRotation: 270
  };
};
module.exports = Params;